import React, { Children, useEffect } from 'react';
import { Avatar, Button, Card, Col, DatePicker, Divider, Dropdown, Form, List, message, Modal, PageHeader, Row, Select, Statistic, Table, Tabs, Tag, TimePicker, Typography } from 'antd';
import { Provider } from 'jotai';
import { useMediaQuery } from 'react-responsive';
import { useBeneficiosPage, useModalRechazarBeneficio, useModalSolicitarBeneficio } from './hooks';
import { ArrowDownOutlined, ArrowUpOutlined, CaretDownOutlined, CheckCircleOutlined, CloseCircleOutlined, ExclamationCircleOutlined, HistoryOutlined, MoreOutlined, StarOutlined, UnorderedListOutlined } from "@ant-design/icons"
import { saveAs } from "file-saver";
import logotipo from "../../../assets/imagenes/logotipo.png";
import { TipoBeneficio } from 'enum';
import { BeneficioService } from 'services/comunicacion-cultura';
import LoginService from 'services/LoginService';

const BeneficiosPage = () => {

    const esDesktop = useMediaQuery({ query: "(min-width: 860px)" });
    const esMovil = useMediaQuery({ query: "(max-width: 860px)" });

    const esJefeInmediato = LoginService.getUsuarioAutenticado().empresaSeleccionada?.colaborador?.jefeInmediato;

    const items = [
        { key: 'mis-beneficios', label: 'Mis Beneficios', children: <MisBeneficiosWeb /> },
        { key: 'pendientes-aprobacion', label: 'Aprobación Pendiente', children: <BeneficiosPendientesAprobacionWeb /> },
        ...(esJefeInmediato ? [{ key: 'historico', label: <span><HistoryOutlined /> Histórico Solicitudes</span>, children: <HistoricoAprobadosWeb /> }] : []),
    ]

    return (
        <Provider>
            {esDesktop &&
                <>
                    <PageHeader
                        title="Beneficios"
                        style={{ paddingLeft: "0px" }}
                    />
                    <div className="card-container">
                        <Tabs
                            type="card"
                            items={items}
                            tabBarExtraContent={<BotonesTabSolicitarBeneficio />}
                            destroyInactiveTabPane={true}
                        />
                    </div>
                </>

            }
            {esMovil &&
                <BeneficiosMovil />
            }


            <ModalSolicitarBeneficios />
            <ModalRechazarBeneficios />
        </Provider>
    );
};

const BotonesTabSolicitarBeneficio = () => {
    const { abrirModal: abrirModalSolicitarBeneficios } = useModalSolicitarBeneficio();

    return (
        <Button
            key="solicitar-beneficio"
            type="primary"
            onClick={abrirModalSolicitarBeneficios}
        >
            Solicitar Beneficio
        </Button>
    )
}

const MisBeneficiosWeb = () => {

    const { beneficios, fetchBeneficios } = useBeneficiosPage();

    useEffect(() => {
        fetchBeneficios();
    }, []);

    const columnas = [
        {
            title: "Tipo",
            dataIndex: "tipo",
            // width: '5%',
            render: (tipo) => {
                switch (tipo) {
                    case TipoBeneficio.HORARIO_FLEXIBLE:
                        return <Tag color="cyan">Horario Flexible</Tag>

                    case TipoBeneficio.HORAS_LIBRES:
                        return <Tag color="green">Horas Libres</Tag>

                    case TipoBeneficio.TELETRABAJO:
                        return <Tag color="blue">Teletrabajo</Tag>
                }
            }
        },
        {
            title: "Fecha",
            dataIndex: "fecha",
            // width: '10%',
        },
        {
            title: "Hora Inicio",
            dataIndex: "horaInicio",
            // width: '10%',
        },
        {
            title: "Hora Fin",
            dataIndex: "horaFin",
            // width: '10%',
        },
        {
            title: "Estado",
            dataIndex: "estado",
            render: (estado) => {
                if (estado === "PENDIENTE") {
                    return <Tag color='orange'>Pendiente</Tag>
                } else if (estado === "APROBADO") {
                    return <Tag color='green'>Aprobado</Tag>
                }
                return <Tag>{estado}</Tag>
            }
            // width: '10%',
        },
    ];

    return (
        <Table
            rowKey={(beneficio) => beneficio.id}
            dataSource={beneficios}
            columns={columnas}
            size='small'
            pagination={false}
        />
    )
}

const BeneficiosPendientesAprobacionWeb = () => {

    const { beneficiosPendientesAprobacion, fetchBeneficiosPendientesAprobacion } = useBeneficiosPage();

    useEffect(() => {
        fetchBeneficiosPendientesAprobacion();
    }, []);

    const columnas = [
        {
            title: "Colaborador",
            dataIndex: 'colaborador',
            render: (fila) => {
                return (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <Typography.Text>{fila.nombres} {fila.apellidoPaterno} {fila.apellidoMaterno}</Typography.Text>
                        <Typography.Text type='secondary'>{fila.numeroDocumentoIdentidad}</Typography.Text>
                    </div>
                )
            }
        },
        {
            title: "Tipo",
            dataIndex: "tipo",
            render: (tipo) => {
                switch (tipo) {
                    case TipoBeneficio.HORARIO_FLEXIBLE:
                        return <Tag color="cyan">Horario Flexible</Tag>

                    case TipoBeneficio.HORAS_LIBRES:
                        return <Tag color="green">Horas Libres</Tag>

                    case TipoBeneficio.TELETRABAJO:
                        return <Tag color="blue">Teletrabajo</Tag>
                }
            }
        },
        {
            title: "Fecha",
            dataIndex: "fecha",
        },
        {
            title: "Hora Inicio",
            dataIndex: "horaInicio",
        },
        {
            title: "Hora Fin",
            dataIndex: "horaFin",
        },

        {
            title: 'Acciones',
            width: ' 5%',
            render: (beneficio) => <MenuAcciones beneficio={beneficio} />
        }
    ];

    return (
        <Table
            rowKey={(beneficio) => beneficio.id}
            dataSource={beneficiosPendientesAprobacion}
            columns={columnas}
            size='small'
            pagination={false}
        />
    )
}

const HistoricoAprobadosWeb = () => {

    const { beneficiosHistorico, fetchBeneficiosHistorico } = useBeneficiosPage();

    useEffect(() => {
        fetchBeneficiosHistorico();
    }, []);

    const columnas = [
        {
            title: "Colaborador",
            dataIndex: 'colaborador',
            render: (fila) => (
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <Typography.Text>{fila.nombres} {fila.apellidoPaterno} {fila.apellidoMaterno}</Typography.Text>
                    <Typography.Text type='secondary'>{fila.numeroDocumentoIdentidad}</Typography.Text>
                </div>
            )
        },
        {
            title: "Tipo",
            dataIndex: "tipo",
            render: (tipo) => {
                switch (tipo) {
                    case TipoBeneficio.HORARIO_FLEXIBLE:
                        return <Tag color="cyan">Horario Flexible</Tag>
                    case TipoBeneficio.HORAS_LIBRES:
                        return <Tag color="green">Horas Libres</Tag>
                    case TipoBeneficio.TELETRABAJO:
                        return <Tag color="blue">Teletrabajo</Tag>
                }
            }
        },
        {
            title: "Fecha",
            dataIndex: "fecha",
        },
        {
            title: "Hora Inicio",
            dataIndex: "horaInicio",
        },
        {
            title: "Hora Fin",
            dataIndex: "horaFin",
        },
        {
            title: "Estado",
            render: () => <Tag icon={<CheckCircleOutlined />} color="success">Aprobado</Tag>
        },
    ];

    return (
        <Table
            rowKey={(beneficio) => beneficio.id}
            dataSource={beneficiosHistorico}
            columns={columnas}
            size='small'
            pagination={{ pageSize: 10, showSizeChanger: false }}
            locale={{ emptyText: 'Sin beneficios aprobados' }}
        />
    );
};

const MenuAcciones = ({ beneficio }) => {

    const { fetchBeneficiosPendientesAprobacion } = useBeneficiosPage();
    const { abrirModal: abrirModalRechazarBeneficio } = useModalRechazarBeneficio();

    const onClick = ({ key }) => {
        switch (key) {
            case "aprobar-beneficio":
                aprobarBeneficio();
                break;

            case "rechazar-beneficio":
                abrirModalRechazarBeneficio(beneficio);
                break;

            default:
                break;
        }
    };

    const aprobarBeneficio = () => {
        Modal.confirm({
            icon: <ExclamationCircleOutlined />,
            content: "¿Está seguro de aprobar el beneficio seleccionado?",
            async onOk() {
                await BeneficioService.aprobar(beneficio.id);
                message.success("Se ha aprobado la solicitud");
                fetchBeneficiosPendientesAprobacion();
            },
            onCancel() { },
            okText: "Si, Aprobar",
            cancelText: "No",
        });
    };

    return (
        <Dropdown
            menu={{
                items: [
                    { label: "Aprobar Beneficio", key: "aprobar-beneficio", icon: <CheckCircleOutlined style={{ fontSize: "16px" }} />, },
                    { label: "Rechazar Beneficio", key: "rechazar-beneficio", icon: <CloseCircleOutlined style={{ fontSize: "16px" }} />, danger: true }
                ],
                onClick
            }}
            placement="bottomRight"
            arrow
            trigger={['click']}
        >
            <Button type="link" className="ant-dropdown-link">
                <MoreOutlined style={{ fontSize: "16px", fontWeight: "bold", color: "#6c757d" }} />
            </Button>
        </Dropdown>
    );
};

const TIPO_COLOR = {
    [TipoBeneficio.TELETRABAJO]: '#1677ff',
    [TipoBeneficio.HORARIO_FLEXIBLE]: '#13c2c2',
    [TipoBeneficio.HORAS_LIBRES]: '#52c41a',
};

const TIPO_LABEL = {
    [TipoBeneficio.TELETRABAJO]: 'Teletrabajo',
    [TipoBeneficio.HORARIO_FLEXIBLE]: 'Horario Flexible',
    [TipoBeneficio.HORAS_LIBRES]: 'Horas Libres',
};

const BeneficiosMovil = () => {

    const { beneficios, fetchBeneficios, beneficiosHistorico, fetchBeneficiosHistorico } = useBeneficiosPage();
    const { abrirModal: abrirModalSolicitarBeneficios } = useModalSolicitarBeneficio();
    const esJefeInmediato = LoginService.getUsuarioAutenticado().empresaSeleccionada?.colaborador?.jefeInmediato;

    useEffect(() => {
        fetchBeneficios();
        if (esJefeInmediato) fetchBeneficiosHistorico();
    }, [])

    return (
        <>
            <div className="container-movil-pdf-header" style={{ display: "flex", "justifyContent": "space-between" }}>
                <div>
                    <img
                        src={logotipo}
                        alt=""
                        style={{ height: "36px", marginRight: "10px" }}
                    />
                    Mis Beneficios
                </div>
                <div>
                    <Button
                        key="descargar-catalogo"
                        type="primary"
                        onClick={abrirModalSolicitarBeneficios}
                    >
                        Solicitar Beneficio
                    </Button>
                </div>
            </div >

            <List
                itemLayout="horizontal"
                dataSource={beneficios}
                locale={{ emptyText: 'Sin beneficios' }}
                renderItem={(item) => (
                    <List.Item style={{ padding: "10px 10px" }}>
                        <List.Item.Meta
                            title={
                                <div>
                                    <div style={{ fontSize: 12, color: "#1677ff" }}>
                                        {item.fecha}
                                    </div>
                                    {item.horaInicio &&
                                        <div style={{ fontSize: 12, color: '#595959' }}>
                                            {item.horaInicio} - {item.horaFin}
                                        </div>
                                    }
                                </div>
                            }
                        />
                        <div style={{ padding: "0px 10px" }}>
                            {item.tipo === TipoBeneficio.HORARIO_FLEXIBLE &&
                                <Tag color="cyan">Horario Flexible</Tag>
                            }
                            {item.tipo === TipoBeneficio.HORAS_LIBRES &&
                                <Tag color="green">Horas Libres</Tag>
                            }
                            {item.tipo === TipoBeneficio.TELETRABAJO &&
                                <Tag color="blue">Teletrabajo</Tag>
                            }
                        </div>
                    </List.Item>
                )}
            />

            {esJefeInmediato && (
                <div style={{ padding: "0 15px" }}>
                    <Divider orientation="left" style={{ fontSize: 13, color: '#595959' }}>
                        <HistoryOutlined style={{ marginRight: 6 }} />
                        Histórico Solicitudes
                    </Divider>

                    <List
                        itemLayout="horizontal"
                        dataSource={beneficiosHistorico}
                        locale={{ emptyText: 'Sin beneficios aprobados' }}
                        renderItem={(item) => {
                            const color = TIPO_COLOR[item.tipo] || '#8c8c8c';
                            const iniciales = item.colaborador
                                ? (item.colaborador.apellidoPaterno?.[0] || '') + (item.colaborador.nombres?.[0] || '')
                                : '?';
                            return (
                                <List.Item style={{ padding: "10px 0" }}>
                                    <List.Item.Meta
                                        avatar={
                                            <Avatar style={{ backgroundColor: color, fontSize: 13 }}>
                                                {iniciales.toUpperCase()}
                                            </Avatar>
                                        }
                                        title={
                                            <div>
                                                <Typography.Text strong style={{ fontSize: 13 }}>
                                                    {item.colaborador?.apellidoPaterno} {item.colaborador?.apellidoMaterno} {item.colaborador?.nombres}
                                                </Typography.Text>
                                                <div style={{ fontSize: 11, color: '#8c8c8c' }}>
                                                    {item.colaborador?.numeroDocumentoIdentidad}
                                                </div>
                                            </div>
                                        }
                                        description={
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                <Tag color={item.tipo === TipoBeneficio.TELETRABAJO ? 'blue' : item.tipo === TipoBeneficio.HORAS_LIBRES ? 'green' : 'cyan'} style={{ margin: 0 }}>
                                                    {TIPO_LABEL[item.tipo]}
                                                </Tag>
                                                <span style={{ fontSize: 11, color: '#595959' }}>{item.fecha}</span>
                                                {item.horaInicio && (
                                                    <span style={{ fontSize: 11, color: '#595959' }}>{item.horaInicio} - {item.horaFin}</span>
                                                )}
                                            </div>
                                        }
                                    />
                                    <CheckCircleOutlined style={{ color: '#52c41a', fontSize: 18 }} />
                                </List.Item>
                            );
                        }}
                    />
                </div>
            )}
        </>
    )
}

const ModalSolicitarBeneficios = () => {

    const [form] = Form.useForm();
    const { open, loading, cerrarModal, guardar } = useModalSolicitarBeneficio();
    const tipo = Form.useWatch('tipo', form);

    return (
        <Modal
            title="Solicitar Beneficio"
            centered
            open={open}
            onCancel={() => {
                form.resetFields();
                cerrarModal();
            }}
            onOk={() => guardar(form)}
            okButtonProps={{ loading: loading }}
            okText="Solicitar Beneficio"
            destroyOnClose={true}
            maskClosable={false}
        >

            <Form form={form} layout="vertical">
                <Form.Item
                    label="Tipo"
                    name="tipo"
                    rules={[{ required: true, message: "Seleccione el tipo" }]}
                >
                    <Select
                        style={{ width: "100%" }}
                        options={[
                            {
                                value: TipoBeneficio.TELETRABAJO,
                                label: 'TELETRABAJO',
                            },
                            {
                                value: TipoBeneficio.HORARIO_FLEXIBLE,
                                label: 'HORARIO FLEXIBLE',
                            },
                            {
                                value: TipoBeneficio.HORAS_LIBRES,
                                label: 'HORAS LIBRES',
                            },
                        ]}
                    >

                    </Select>
                </Form.Item>

                <Form.Item
                    label="Fecha"
                    name="fecha"
                    labelAlign="left"
                    rules={[{ required: true, message: "Ingrese fecha" }]}
                >
                    <DatePicker
                        allowClear={true}
                        format="DD/MM/YYYY"
                        style={{ width: "100%" }}
                    />
                </Form.Item>

                {tipo === TipoBeneficio.HORAS_LIBRES &&

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Hora Incio"
                                name="horaInicio"
                                rules={[{ required: true, message: "Seleccione la hora inicio" }]}
                            >
                                <Select
                                    style={{ width: "100%" }}
                                    options={[
                                        { value: 5, label: '05 AM' },
                                        { value: 6, label: '06 AM' },
                                        { value: 7, label: '07 AM' },
                                        { value: 8, label: '08 AM' },
                                        { value: 9, label: '09 AM' },
                                        { value: 10, label: '10 AM' },
                                        { value: 11, label: '11 AM' },
                                        { value: 12, label: '12 PM' },
                                        { value: 13, label: '01 PM' },
                                        { value: 14, label: '02 PM' },
                                        { value: 15, label: '03 PM' },
                                        { value: 16, label: '04 PM' },
                                        { value: 17, label: '05 PM' },
                                        { value: 18, label: '06 PM' },
                                        { value: 19, label: '07 PM' },
                                        { value: 20, label: '08 PM' },
                                        { value: 21, label: '09 PM' },
                                        { value: 22, label: '10 PM' },
                                        { value: 23, label: '11 PM' },
                                    ]}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="Hora Fin"
                                name="horaFin"
                                rules={[{ required: true, message: "Seleccione la hora fin" }]}
                            >
                                <Select
                                    style={{ width: "100%" }}
                                    options={[
                                        { value: 5, label: '05 AM' },
                                        { value: 6, label: '06 AM' },
                                        { value: 7, label: '07 AM' },
                                        { value: 8, label: '08 AM' },
                                        { value: 9, label: '09 AM' },
                                        { value: 10, label: '10 AM' },
                                        { value: 11, label: '11 AM' },
                                        { value: 12, label: '12 PM' },
                                        { value: 13, label: '01 PM' },
                                        { value: 14, label: '02 PM' },
                                        { value: 15, label: '03 PM' },
                                        { value: 16, label: '04 PM' },
                                        { value: 17, label: '05 PM' },
                                        { value: 18, label: '06 PM' },
                                        { value: 19, label: '07 PM' },
                                        { value: 20, label: '08 PM' },
                                        { value: 21, label: '09 PM' },
                                        { value: 22, label: '10 PM' },
                                        { value: 23, label: '11 PM' },
                                    ]}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                }

            </Form>

        </Modal>
    )
}


const ModalRechazarBeneficios = () => {

    const [form] = Form.useForm();
    const { open, loading, cerrarModal, rechazar } = useModalRechazarBeneficio();

    return (
        <Modal
            title="Solicitar Beneficio"
            centered
            open={open}
            onCancel={() => {
                form.resetFields();
                cerrarModal();
            }}
            onOk={() => rechazar(form)}
            okButtonProps={{ loading: loading }}
            okText="Rechazar Solicitud"
        >

            <Form form={form} layout="vertical">
                <Form.Item
                    label="Motivo"
                    name="motivo"
                    rules={[{ required: true, message: "Seleccione el motivo de rechazo" }]}
                >
                    <Select
                        style={{ width: "100%" }}
                        options={[
                            {
                                value: "Reunión Programada",
                                label: 'Reunión Programada',
                            },
                            {
                                value: "Pendientes de entrega de informacion",
                                label: "Pendientes de entrega de informacion",
                            },
                            {
                                value: "Mucha demanda de operatividad diaria",
                                label: "Mucha demanda de operatividad diaria",
                            },
                            {
                                value: "No fue solicitado con tiempo segun politicas",
                                label: "No fue solicitado con tiempo segun politicas",
                            },


                        ]}
                    >

                    </Select>
                </Form.Item>

            </Form>

        </Modal>
    )
}


export default BeneficiosPage;